<template> </template>

<script>
export default {
	name: 'ChoosePlanet',
};
</script>

<style scoped></style>
